import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
import type { VxeColumnProps, VxeColumnPropTypes } from "vxe-table";

export interface ColumnItemOption {
  id: string | number | boolean;
  text: string;
}
export type ColumnOption = ColumnItemOption[] | (() => ColumnItemOption[]);

export interface ColumnItem extends VxeColumnProps {
  id?: string | number;
  /**
   * 自定义列 是否选中 控制显影
   */
  checked?: boolean;
  /**
   * 自定义禁止操作 勾选和换位置
   */
  disabled?: boolean;
  /**
   * 自定义列 是否默认选中
   */
  default?: boolean;
  /**
   * 后缀 直接拼接在后面
   */
  suffix?: string;
  /**
   * 前缀 接口数据对应的字段key
   */
  prefix?: string;
  /**
   * 标记改列显示合计数据
   */
  summary?: boolean;
  /**
   * 插槽
   */
  slots?: VxeColumnPropTypes.Slots;
  /**
   * options  应用于key - value映射
   */
  options?: ColumnOption;
  /** 是否入自定义列 */
  notCustomColumn?: boolean;
  /** 是否处理 */
  noFormat?: boolean;
  summaryNum?: number;
  /* 分组 */
  group?: string;
}
export interface TablePagination {
  page: number;
  pagesize: number;
  total?: number;
  layout?: string;
  background?: boolean;
}

export const vxeTableProps = buildProps({
  /** 列的配置项  */
  columns: {
    type: definePropType<ColumnItem[]>(Array),
    default: () => [],
  },
  /** 表格数据 */
  list: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  tooltipConfig: {
    type: Object,
    default: () => {
      return {
        enterable: true,
        leaveDelay: 500,
      };
    },
  },
} as const);

export type VxeTableProps = ExtractPropTypes<typeof vxeTableProps>;
